import {getExportStylesFromColumnCb} from './getExportStylesFromColumn'
import {IColumnItem} from "@ui/tableCustom/types/columns";
import {Worksheet} from "exceljs";

export const generateStylesHeadColumnsExcelJs = <T>({columns, worksheet,columnLabelKey='title',disableChangeWidthSizeColumn}: {
    columns: IColumnItem<T>[],
    worksheet: Worksheet,
    columnLabelKey?:keyof IColumnItem<T>,
    disableChangeWidthSizeColumn:boolean
}) => {
    columns.forEach((column, index) => {
        const columnNumber = index + 1;
        const exportStyles = getExportStylesFromColumnCb(column)
        if (!disableChangeWidthSizeColumn && exportStyles?.width?.wch) {
            worksheet.getColumn(columnNumber).width = Number(exportStyles.width.wch);
            return;
        }

        if (!disableChangeWidthSizeColumn && columnLabelKey && columnLabelKey in column && typeof  column[columnLabelKey] === 'string') {
            const label = column[columnLabelKey] as string
            worksheet.getColumn(columnNumber).width = label.length + 2
        }
    });
}


